import { ActivedDot, Container, DisabledDot } from './styles'

export const ProgressIndicatorDot = () => (
  <Container>
    <ActivedDot />
    <DisabledDot />
  </Container>
)
